import { useEffect, useState } from 'react';
import { useMobileDetect } from '@/hooks/useMobileDetect';

export function useModalKeyboard(
  enabled: boolean,
  heightTarget: HTMLElement | null = null
) {
  const { isIos } = useMobileDetect();
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsKeyboardOpen(false);
      return;
    }

    const vv = window.visualViewport;
    if (!vv) return;

    let rafId = 0;

    const update = () => {
      const keyboardHeight = Math.max(0, window.innerHeight - vv.height);
      const nextIsOpen = keyboardHeight > 100;

      setIsKeyboardOpen(prev => (prev === nextIsOpen ? prev : nextIsOpen));

      if (isIos && heightTarget) {
        heightTarget.style.setProperty(
          '--ios-modal-keyboard-height',
          `${keyboardHeight}px`
        );
      }
    };

    const scheduleUpdate = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    update();
    vv.addEventListener('resize', scheduleUpdate);
    vv.addEventListener('scroll', scheduleUpdate);

    return () => {
      cancelAnimationFrame(rafId);
      vv.removeEventListener('resize', scheduleUpdate);
      vv.removeEventListener('scroll', scheduleUpdate);
      heightTarget?.style.removeProperty('--ios-modal-keyboard-height');
      setIsKeyboardOpen(false);
    };
  }, [enabled, isIos, heightTarget]);

  return { isKeyboardOpen };
}
